import { render } from "./GalleryNavigator.vue?vue&type=template&id=c4a48114&scoped=true"
import script from "./GalleryNavigator.vue?vue&type=script&lang=js"
export * from "./GalleryNavigator.vue?vue&type=script&lang=js"

import "./GalleryNavigator.vue?vue&type=style&index=0&id=c4a48114&scoped=true&lang=css"

import exportComponent from "/builds/alex-yonge-photography/alex-yonge-photographs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a48114"]])

export default __exports__